import { useMutation } from '@tanstack/react-query';
import { GitlabClient } from '../httpClients/GitlabClient';
import { GitlabProvisioningConnectRequest } from '../httpClients/GitlabClient/api.schema';
import { MUTATION_KEYS } from './consts';

/**
 * v2 wizard — validates a pasted GitLab URL + access token and resolves the
 * install capability (host, edition, webhook support, tier, bot type). No DB
 * writes; the transient token is stashed in a short-lived BE session. Typed
 * errors (`{ code, message }`) are mapped to reason-specific copy by the Connect
 * step, so this hook does not toast.
 * @returns TanStack mutation whose data holds the resolved connect capability.
 */
export const useGitlabProvisioningConnectMutation = () =>
  useMutation({
    mutationKey: [MUTATION_KEYS.GITLAB_PROVISIONING_CONNECT],
    mutationFn: (request: GitlabProvisioningConnectRequest) =>
      GitlabClient.provisioningConnect(request),
  });
